class Logger {
  log(msg, msg2) {
    if (process.env.NODE_ENV !== 'production') console.log(msg, msg2 || '');
  }

  warn(msg, msg2) {
    if (process.env.NODE_ENV !== 'production') console.warn(msg, msg2 || '');
  }

  error(msg, msg2) {
    if (process.env.NODE_ENV !== 'production') console.error(msg, msg2 || '');
  }
}

const Debugger = new Logger();

export default Debugger;
